import { UTCDate } from '@date-fns/utc';
import { endOfMonth, startOfMonth, subMonths } from 'date-fns';
import { Stack } from '../../../../design-system/stack/stack';
import { AccountView } from '../../../../types/entity-types';
import { SupportedCountryCurrency } from '../../../../types/supported-country-currency';
import { EstimatedRunwayChart } from '../../components/charts/estimated-runway-chart';
import { getCurrentCashData } from '../../utils/get-current-cash-data';
import { getEstimatedRunwayData } from '../../utils/get-estimated-runway-data';
import { getRunwayChartData } from '../../utils/get-runway-chart-data';

type RunwayChartWrapperProps = {
  accounts: AccountView[];
  baseCurrency: string;
};

export const RunwayChartWrapper = ({ accounts, baseCurrency }: RunwayChartWrapperProps) => {
  const now = new UTCDate();

  const estimatedRunwayData = getEstimatedRunwayData({
    accounts,
    baseCurrency: baseCurrency as SupportedCountryCurrency,
    currentPeriodStartDate: startOfMonth(now),
    currentPeriodEndDate: endOfMonth(now),
    previousMonthStartDate: startOfMonth(subMonths(now, 1)),
    previousMonthEndDate: endOfMonth(subMonths(now, 1)),
  });

  const currentBalance = getCurrentCashData({
    accounts,
    baseCurrency: baseCurrency as SupportedCountryCurrency,
    startDate: startOfMonth(now),
    endDate: endOfMonth(now),
  });

  if (!currentBalance.currentCashInBaseCurrency) {
    return null;
  }

  return (
    <Stack className="w-full" space={4}>
      <h2 className="text-xl font-medium">Estimated Runway</h2>
      <div className="w-full rounded-[10px] border-[0.5px] border-seapoint-gray-border px-4 pb-4 pt-8">
        <EstimatedRunwayChart
          height={200}
          data={getRunwayChartData(accounts, baseCurrency as SupportedCountryCurrency, now)}
          baseCurrency={baseCurrency as SupportedCountryCurrency}
          isGrowing={estimatedRunwayData.trend === 'increasing'}
        />
      </div>
    </Stack>
  );
};
